import {
  Create,
  Datagrid,
  DateField,
  Edit,
  EditButton,
  Resource,
  SelectInput,
  Show,
  SimpleForm,
  Tab,
  TabbedShowLayout,
  TextField,
  TextInput,
  required,
} from "react-admin";
import VersionedList, {
  DbVersionFilterInput,
  DbVersionField,
  DbVersionInput,
} from "../components/DbVersion";
import { TRIMMING_UNITS } from "../consts";

const TrimmingFilters = [
  <TextInput
    key="trimmingNameSearch"
    label="Search by name"
    source="name"
    alwaysOn
  />,
  <DbVersionFilterInput key="trimmingDbVersion" alwaysOn />,
];

const TrimmingList = (props) => (
  <VersionedList {...props} resource="trimming" filters={TrimmingFilters}>
    <div style={{ marginTop: "15px" }}>
      <Datagrid rowClick="show">
        <TextField source="id" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
        <TextField source="name" />
        <TextField source="unit" label="Unit" />
        <TextField source="ecobalyseId" label="Ecobalyse ID" emptyText="-" />
        <DbVersionField />
        <EditButton />
      </Datagrid>
    </div>
  </VersionedList>
);

const ShowTrimming = (props) => (
  <Show {...props} resource="trimming">
    <TabbedShowLayout>
      <Tab label="Main">
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="unit" label="Unit" />
        <TextField source="ecobalyseId" label="Ecobalyse ID" emptyText="-" />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </Tab>
    </TabbedShowLayout>
  </Show>
);

const CreateTrimming = (props) => (
  <Create {...props} resource="trimming">
    <SimpleForm>
      <DbVersionInput />
      <TextInput source="name" validate={[required()]} />
      <SelectInput
        source="unit"
        label="Unit"
        choices={TRIMMING_UNITS}
        validate={[required()]}
      />
      <TextInput source="ecobalyseId" label="Ecobalyse ID" />
    </SimpleForm>
  </Create>
);

const EditTrimming = (props) => (
  <Edit {...props} resource="trimming">
    <SimpleForm>
      <DbVersionInput />
      <TextInput source="name" validate={[required()]} />
      <SelectInput
        source="unit"
        label="Unit"
        choices={TRIMMING_UNITS}
        validate={[required()]}
      />
      <TextInput source="ecobalyseId" label="Ecobalyse ID" />
    </SimpleForm>
  </Edit>
);

const trimmingResource = () => (
  <Resource
    name="trimming"
    options={{ label: "Trimming", menuGroup: "Bcome" }}
    list={TrimmingList}
    show={ShowTrimming}
    create={CreateTrimming}
    edit={EditTrimming}
    path="process/trimmings"
  />
);

export { trimmingResource };
